import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import Waiting from '../components/waiting';
import { querystring, buildQueryString } from '../utils/helpers';
import { useParams, useNavigate } from 'react-router-dom';
import { useStores } from '../hooks/use-stores';

function DirectSignIn() {
    const navigate = useNavigate();
    let { token } = useParams();
    const { authStore, store } = useStores();
    const { emailLoginError, currentUser } = authStore;
    const { contextParams } = store;
    useEffect(() => {
        authStore.directSignin(token);
    }, []);

    const redirectUrl = useMemo(() => {
        let redirect = querystring('redirect') || '/';
        if (!redirect.startsWith('/')) redirect = `/${redirect}`;
        if (redirect === '/') {
            redirect = `${redirect}?${buildQueryString(store.contextParams)}`;
        }
        return redirect;
    }, [contextParams]);

    useEffect(() => {
        if (currentUser) navigate(redirectUrl);
        if (emailLoginError) navigate('/auth/error/email');
    }, [emailLoginError, currentUser, navigate, redirectUrl]);

    return <Waiting waitingActive={true} from="DirectSignIn" />;
}

export default observer(DirectSignIn);
